export default "__VITE_ASSET__7553ac41__"